const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const PKW_IMAGES = ["/1.jpeg", "/2.jpeg", "/4.jpeg", "/5.jpeg", "/6.jpeg"];
export const AGRAR_LKW_IMAGES = ["/3.jpeg", "/7.jpeg"];

/** Alias for LKW: no dedicated truck photo available; using agrar/utility vehicles. */
export const LKW_IMAGES = AGRAR_LKW_IMAGES;
export const AGRAR_IMAGES = AGRAR_LKW_IMAGES;

export default pickRandom;
